import React from "react"
import { SimpleGrid } from "@chakra-ui/react"
import AddContentButton from "components/Builder/AddContentButton"
import EditorSection from "components/Builder/components/EditorSection"
import { BuilderBlockType, BuilderType } from "sharedTypes/builder"

type Props = {
  builderType: BuilderType
}

const AddContentSection = ({ builderType }: Props) => {
  const configuration = {
    [BuilderBlockType.HEADING]: {
      text: "Heading", icon: "email-block-headline", type: BuilderBlockType.HEADING,
    },
    [BuilderBlockType.TEXT]: {
      text: "Paragraph", icon: "email-block-text", type: BuilderBlockType.TEXT,
    },
    [BuilderBlockType.IMAGE]: {
      text: "Image", icon: "email-block-image", type: BuilderBlockType.IMAGE,
    },
    [BuilderBlockType.DIVIDER]: {
      text: "Divider", icon: "email-block-divider", type: BuilderBlockType.DIVIDER,
    },
    [BuilderBlockType.SPACER]: {
      text: "Spacer", icon: "email-block-spacer", type: BuilderBlockType.SPACER,
    },
    [BuilderBlockType.BUTTON]: {
      text: "Button", icon: "email-block-button", type: BuilderBlockType.BUTTON,
    },
    [BuilderBlockType.QR_CODE]: {
      text: "QR Code", icon: "email-block-qr-code", type: BuilderBlockType.QR_CODE,
    },
    [BuilderBlockType.WALLET_PASS]: {
      text: "Wallet Pass", icon: "email-block-wallet-pass", type: BuilderBlockType.WALLET_PASS,
    },
    [BuilderBlockType.HTML]: {
      text: "HTML", icon: "email-block-html", type: BuilderBlockType.HTML,
    },
    [BuilderBlockType.QUESTION]: {
      text: "Question", icon: "custom-question", type: BuilderBlockType.QUESTION,
    },
  }

  const optionsToRender = (() => {
    switch (builderType) {
      case BuilderType.Email:
        return [
          configuration[BuilderBlockType.HEADING],
          configuration[BuilderBlockType.TEXT],
          configuration[BuilderBlockType.IMAGE],
          configuration[BuilderBlockType.DIVIDER],
          configuration[BuilderBlockType.SPACER],
          configuration[BuilderBlockType.BUTTON],
          configuration[BuilderBlockType.QR_CODE],
          configuration[BuilderBlockType.WALLET_PASS],
          configuration[BuilderBlockType.HTML],
        ]
      case BuilderType.Webpage:
        return [
          configuration[BuilderBlockType.HEADING],
          configuration[BuilderBlockType.TEXT],
          configuration[BuilderBlockType.IMAGE],
          configuration[BuilderBlockType.DIVIDER],
          configuration[BuilderBlockType.SPACER],
          configuration[BuilderBlockType.BUTTON],
          configuration[BuilderBlockType.HTML],
        ]
      case BuilderType.Form:
      default:
        return [
          configuration[BuilderBlockType.TEXT],
          configuration[BuilderBlockType.DIVIDER],
          configuration[BuilderBlockType.SPACER],
          configuration[BuilderBlockType.IMAGE],
          configuration[BuilderBlockType.QUESTION],
        ]
    }
  })()

  return (
    <EditorSection>
      <SimpleGrid spacing={3.5} minChildWidth={32} mt={7} mb={7} justifyItems="center">
        {optionsToRender.map(({ text, icon, type }) => (
          <AddContentButton
            key={type}
            text={text}
            icon={icon}
            type={type}
          />
        ))}
      </SimpleGrid>
    </EditorSection>
  )
}

export default AddContentSection
